import * as XLSX from "xlsx";

export const PURCHASE_DETAIL_IMPORT_HEADERS = [
  "ID de Producto",
  "Código alterno",
  "Lote",
  "Fecha de expiración",
  "Nombre de Producto",
  "Cantidad",
  "P. Unit.",
  "Gravado",
  "Exento",
  "No Sujeto",
  "Total",
];

export const downloadPurchaseDetailImportTemplate = () => {
  const workbook = XLSX.utils.book_new();
  const worksheet = XLSX.utils.aoa_to_sheet([PURCHASE_DETAIL_IMPORT_HEADERS]);

  worksheet["!cols"] = [
    { wch: 18 },
    { wch: 18 },
    { wch: 18 },
    { wch: 18 },
    { wch: 40 },
    { wch: 12 },
    { wch: 12 },
    { wch: 12 },
    { wch: 12 },
    { wch: 12 },
    { wch: 12 },
  ];

  worksheet["!autofilter"] = {
    ref: "A1:K1",
  };

  XLSX.utils.book_append_sheet(workbook, worksheet, "Detalle de compra");
  XLSX.writeFile(workbook, "Plantilla_Importacion_Detalle_Compra.xlsx");
};
